import { InlineIcon } from "@iconify/react";

const SmallSpinner = ({ className }) => {
    return (
        <div className={`spinner-container px-2 ${className}`}>
            <InlineIcon icon="line-md:loading-loop" />
        </div>
    );
};

export default SmallSpinner;
